<template>
  <div>
    <HMTabs v-model="tab" class="w-100 mt-2 mb-4">
      <HMTab name="available">
        {{ $t('STUDIO.LINKS.AVAILABLE') }}
      </HMTab>
      <HMTab name="used">
        {{ $t('STUDIO.LINKS.USED_AND_EXPIRED') }}
      </HMTab>
    </HMTabs>
    <div v-if="tab === 'available'">
      <div class="table-wrap">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">
                {{ $t('STUDIO.LABELS.CLASSCARD') }}
              </th>
              <th scope="col">
                {{ $t('STUDIO.LABELS.AVAILABLE') }}
              </th>
              <th scope="col">
                {{ $t('STUDIO.LABELS.EXPIRATION_DATE') }}
              </th>
            </tr>
          </thead>
          <tr v-for="punch in getActivePunches" :key="punch.id">
            <td>
              {{ punch.classcard_name }}
            </td>
            <td>
              {{ punch.number_of_punches }}
            </td>
            <td>
              {{ formatDate(punch.expiration) }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div v-else>
      <div class="table-wrap">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">
                {{ $t('STUDIO.LABELS.EVENT') }}
              </th>
              <th scope="col">
                {{ $t('STUDIO.LABELS.EVENT_TIME') }}
              </th>
              <th scope="col">
                {{ $t('STUDIO.LABELS.PURCHASE_DATE') }}
              </th>
              <th scope="col">
                {{ $t('STUDIO.LABELS.EXPIRATION_DATE') }}
              </th>
              <th></th>
            </tr>
          </thead>
          <tr v-for="punch in getUsedPunches" :key="punch.id">
            <td class="p m-0">
              {{ punch.event_name || punch.reason }}
            </td>
            <td>
              {{ formatDate(punch.event_datetime) }}
            </td>
            <td>
              {{ formatDate(punch.purchase_time) }}
            </td>
            <td>
              {{ formatDate(punch.expiration) }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import HMTabs from '@/web/components/common/HMTabs';
import HMTab from '@/web/components/common/HMTab';
import { getActivePunches, getUsedPunches } from '@/core/utils/classcards';

export default Vue.extend({
  name: 'StudentClassCard',
  components: {
    HMTabs,
    HMTab,
  },
  computed: {
    ...mapGetters({
      punches: 'user/punches',
      currentStudio: 'studio/currentStudio',
    }),
    getActivePunches() {
      return getActivePunches(this.punches);
    },
    getUsedPunches() {
      return getUsedPunches(this.punches);
    },
  },
  data() {
    return {
      tab: 'available',
    };
  },
  methods: {
    formatDate(date) {
      if (date === null) {
        return 'Unused';
      }
      return this.$formatDate(date, 'date-word');
    },
  },
  mounted() {
    this.$store.dispatch('user/studentPunches');
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.table-wrap {
  overflow-x: auto;
}
</style>
